var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShield(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon-Architecture/48/Arch_AWS-Shield_48") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#dd344c",
    d: "M0 0h64v64H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M43.002 38.985h-2v3h-3v2h3v3h2v-3h3v-2h-3zm5 4c0-3.309-2.69-6-6-6s-6 2.691-6 6 2.691 6 6 6 6-2.69 6-6m2 0c0 4.411-3.589 8-8 8s-8-3.589-8-8 3.59-8 8-8 8 3.59 8 8m-22 3.291v-27.68l-8 4.017v15.031c.002.338.155 8.016 8 8.632m11-12.83v-10.79l-9-4.122v27.764c.851-.06 1.68-.19 2.44-.385.2.65.462 1.272.783 1.858-1.29.36-2.744.565-4.223.565-10.874 0-11-10.585-11-10.692V21.997a1 1 0 0 1 .552-.894l10-5.02a1 1 0 0 1 .864-.016l11 5.04a1 1 0 0 1 .584.908v11.021a10 10 0 0 0-2 .41m-3.242 17.34c.656.525 1.38.968 2.155 1.317-2.437 1.041-5.698 1.677-8.913 1.677-4.496 0-8.158-1.418-10.885-4.216-5.285-5.423-5.124-14.036-5.115-14.4V17.997c0-.389.226-.742.577-.907l15-6.996a1 1 0 0 1 .823-.009l16 6.996c.365.16.6.518.6.916v15.83a10 10 0 0 0-2-.64V18.651l-14.986-6.553-14.014 6.536V35.19c-.002.106-.14 8.176 4.556 12.986 2.334 2.392 5.511 3.604 9.444 3.604 2.387 0 4.782-.367 6.758-.995"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShield);
export default __webpack_public_path__ + "static/media/shield.c4fc3741e431f9aa216821fe910bfc69.svg";
export { ForwardRef as ReactComponent };